import React from 'react'
import { BookEventWrapper } from './styles'
import Button from '../Button'
import { Header2 } from '../../styles/Components'
import { gsColors } from '../../styles/Variables'

const BookEvent = ({ handleClick }) => {
  return (
    <BookEventWrapper>
      <Header2 align="center">
        Let&apos;s take your event to
        <br /> the next level
      </Header2>
      <Button large color={gsColors.sunsetOrange} onClick={handleClick}>
        Get Started
      </Button>
    </BookEventWrapper>
  )
}

export default BookEvent
